var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnpublish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 0.166707L15.5 3.50004C15.5 4.65282 15.0936 5.6356 14.2808 6.44837C13.4686 7.2606 12.4861 7.66671 11.3333 7.66671L3.66667 7.66671L6.66667 10.6667L5.5 11.8334L0.5 6.83337L5.5 1.83337L6.66667 3.00004L3.66667 6.00004L11.3333 6.00004C12.0278 6.00004 12.6181 5.75698 13.1042 5.27087C13.5903 4.78476 13.8333 4.19448 13.8333 3.50004L13.8333 0.166707L15.5 0.166707Z",
    fill: "#1B436E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnpublish);
export default __webpack_public_path__ + "static/media/unpublish.e0e64e64511fc9f0c668bc6f1caa5cdb.svg";
export { ForwardRef as ReactComponent };